import React from "react";

import { useTranslation } from "react-i18next";
import { Chip, Divider, Modal, Paper, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BoxContent = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: theme.palette.background.paper,
  border: theme.palette.background.paper,
  borderRadius: "10px",
  boxShadow: 24,
  padding: 20,
  textAlign: "center",
}));

const SuccessModal = ({ success, clearModalHandler }) => {
  const { t } = useTranslation();

  return (
    <Modal
      disableScrollLock={true}
      open={success}
      onClose={clearModalHandler}
      aria-labelledby="application-succes-title"
      aria-describedby="application-success-description"
    >
      <BoxContent>
        <Typography variant="subtitle1" id="job-success-title">
          {t("modals.applySuccessTitle")}
        </Typography>
        <Typography
          color="text.secondary"
          variant="subtitle2"
          id="application-success-description"
        >
          {t("modals.applySuccessBody")}
        </Typography>
        <Divider sx={{ margin: "0.5rem auto " }} />
        <Stack alignItems="end">
          <Chip
            label={t("modals.successClose")}
            color="primary"
            clickable
            component="button"
            size="small"
            onClick={clearModalHandler}
          />
        </Stack>
      </BoxContent>
    </Modal>
  );
};

export default SuccessModal;
